//import Dropzone from "dropzone";

document.addEventListener('DOMContentLoaded', () => {

    // let myDropzone = new Dropzone("#js-dropzone-form");
    // myDropzone.on("addedfile", file => {
    //     console.log(`File added: ${file.name}`);
    // });

    const chat = document.getElementById('js-chat');
    if (typeof chat !== 'undefined' && chat !== null) {
        const diff = chat.scrollHeight - chat.offsetHeight;
        chat.scrollTop = diff;
    }

});
